<span id="ask-ai-dashboard" class="ask-ai-nav-panel-title ask-ai-pointer"
      *ngIf="enable"
      (click)="display = true; getChatHistory()">
    <i class="ask-ai-icon-white"></i> {{'AskAI' | translate}}
</span>

<p-sidebar position="right" styleClass="p-sidebar p-sidebar-right"
           *ngIf="enable && display"
           [(visible)]="display"
           [baseZIndex]="1000"
           (onHide)="closeSidebar()">
    <div id="ask-ai-title" class="ask-ai-title">
        <p>
          <i class="ask-ai-icon-black"></i> {{'AskAI' | translate}}
          <i title="{{'Clear the history' | translate}}" class="fs6 trash-history icon__DeleteTrash" *ngIf="answers.length && !loading" (click)="clearHistory()"></i>
        </p>
    </div>
    <hr class="ask-ai-hr"/>
    <div class="ask-ai-container">
        <div #scroll id="ask-ai-answers-area" class="ask-ai-answers-area">
            <div class="example" *ngIf="!answers.length">
                <div class="user-profile">
                    <gen-user-profile [name]="'IFU'"
                                      [backgroundColor]="'#000'"
                                      [layout]="'INITIALS_ONLY'">
                    </gen-user-profile>
                </div>
                <div class="example-list">
                    <div>You can ask any question related to the application functionality. For example:<br /></div>
                    <ol class="example-question-list">
                        <li>How can I filter the worklist?</li>
                        <li>Can I reassign a case?</li>
                        <li>How to manage tags?</li>
                    </ol>
                </div>
            </div>
			      <div  *ngFor="let answer of this.answers; let last = last; let idx=index" id="block_{{idx}}">
                <div class="ask-ai-answers-area-question">
                    <div class="user-profile">
                        <gen-user-profile [name]="practitionerName"
                                          [backgroundColor]="'#2B86B2'"
                                          [layout]="'INITIALS_ONLY'">
                        </gen-user-profile>
                    </div>
                    <div class="question">{{answer.question}}</div>
                </div>
                <div class="ask-ai-answers-area-answer">
                    <div class="user-profile">
                        <gen-user-profile [name]="'IFU'"
                                          [backgroundColor]="'#000'"
                                          [layout]="'INITIALS_ONLY'">
                        </gen-user-profile>
                    </div>
                    <div class="answer" [ngStyle]="last ? {'margin-bottom': '4rem'} : {}" [innerHTML]="answer.answer"></div>
                </div>
            </div>
        </div>
        <div id="ask-ai-questions-area" class="ask-ai-question-area">
            <div class="ask-ai-question-container">
                <div class="ask-ai-text">
                    <input id="ask-ai-question-field" pInputText class="ask-ai-question"
                           (keydown)="askQuestionKeyEvent($event)"
                           [(ngModel)]="question"
                           [disabled]="loading"
                           [title]="question"
                           [placeholder]="'Ask question here' | translate" />
                </div>
                <div class="ask-ai-button">
                    <gen-button class="Auto_New_Test_Button"
                                (click)="askQuestion()"
                                [text]="'Ask' | translate"
                                [disabled]="question === '' || loading">
                    </gen-button>
                </div>
                <div class="ask-ai-disclaimer"><b>Note:</b> The purpose of the AI tool is to aid users by providing an answer to the user’s question based on the instructions for use content. You are always required to read the instructions for use before utilizing the product.</div>
            </div>
        </div>
    </div>
</p-sidebar>
